import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/dnd-beyond-logo.svg")